import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WarningIcon from '@mui/icons-material/Warning';
import SendIcon from '@mui/icons-material/Send';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CancelIcon from '@mui/icons-material/Cancel';
import type { InvoiceStatusDisplay } from '../../utils/invoiceStatus';

interface StatusBadgeProps {
  status: InvoiceStatusDisplay;
  size?: 'small' | 'medium';
}

const statusConfig: Record<InvoiceStatusDisplay, {
  label: string;
  backgroundColor: string;
  icon: React.ReactElement;
}> = {
  paid: {
    label: 'Paid',
    backgroundColor: '#2E7D32',
    icon: <CheckCircleIcon fontSize="small" />,
  },
  unpaid: {
    label: 'Unpaid',
    backgroundColor: '#E07A3F',
    icon: <ScheduleIcon fontSize="small" />,
  },
  overdue: {
    label: 'Overdue',
    backgroundColor: '#D32F2F',
    icon: <WarningIcon fontSize="small" />,
  },
  sent: {
    label: 'Sent',
    backgroundColor: '#1976D2',
    icon: <SendIcon fontSize="small" />,
  },
  draft: {
    label: 'Draft',
    backgroundColor: '#757575',
    icon: <EditNoteIcon fontSize="small" />,
  },
  cancelled: {
    label: 'Cancelled',
    backgroundColor: '#616161',
    icon: <CancelIcon fontSize="small" />,
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status] || statusConfig.unpaid;

  return (
    <Chip
      label={config.label}
      icon={config.icon}
      size={size}
      sx={{
        backgroundColor: config.backgroundColor,
        color: '#ffffff',
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: '#ffffff',
        },
      }}
    />
  );
};

export default StatusBadge;
